import React, { useEffect } from 'react';
import {
  DetailsItem,
  DetailsLabel,
  DetailsLayout,
  DetailsText,
  MediaCont,
  MediaSection,
  ProjectDetailsCont,
} from './ProjectDetails.styles';
import { useProjectDetailsParser } from './useProjectDetailsParser';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { Paper } from '@material-ui/core';
import ProjectDetailsLoader from './ProjectDetailsLoader';
import MediaItem from '../MediaItems/MediaItem';
import { customSort } from 'shared/interfaces/utils/IMediaFileType';

interface Props {
  projectId: string;
}

const ProjectDetails: React.FC<Props> = ({ projectId }) => {
  const {
    conflicts,
    usageRun,
    additionalDetails,
    referenceMedia,
    projectLoading = true,
  } = useProjectDetailsParser(projectId, false);

  // useEffect(() => {
  //   console.log('ProjectDetails Rendered', projectId);
  // });

  if (projectLoading) return <ProjectDetailsLoader />;

  return (
    <ProjectDetailsCont>
      <CustomTypography style={{ fontWeight: 500 }}>Project Overview</CustomTypography>
      <DetailsLayout>
        <DetailsItem maxwidth={215} style={{ minWidth: 215 }}>
          <DetailsLabel>Conflict:</DetailsLabel>
          <DetailsText>{conflicts}</DetailsText>
        </DetailsItem>
        <DetailsItem bordered={1}>
          <DetailsLabel>Usage/Run:</DetailsLabel>
          <DetailsText>{usageRun}</DetailsText>
        </DetailsItem>
        <DetailsItem>
          <DetailsLabel>Additional Details:</DetailsLabel>
          <DetailsText>{additionalDetails}</DetailsText>
        </DetailsItem>
        {referenceMedia ? (
          <MediaSection>
            <DetailsLabel>Reference Media:</DetailsLabel>
            <MediaCont>
              {referenceMedia.sort(customSort).map((media) => (
                <MediaItem key={media.id} file={media} />
              ))}
            </MediaCont>
          </MediaSection>
        ) : (
          <React.Fragment />
        )}
      </DetailsLayout>
    </ProjectDetailsCont>
  );
};

export default React.memo(ProjectDetails);
